export const NEAR_DISTANCE = 160 * 1000;
